import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";

import { Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseConfigService } from "@fuse/services/config.service";
import { AuthService } from "app/services/auth.service";
import { SnackBarService } from "app/services/snackbar.service";
import * as moment from "moment";
import { ScheduleService } from "../schedule/schedule.service";
import { UnregisteredScheduleService } from "../unregistered-schedule/unregistered-schedule.service";
import { LoginService } from "./login.service";

@Component({
    selector: "login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    progessbar = false;
    professional: any;
    procedure: any;

    cpfPacient = JSON.parse(localStorage.getItem("cpfpaciente"));
    nascimentoPacient = JSON.parse(localStorage.getItem("nascimentopaciente"));
    enterprise: any;
    logo: any;

    button = true;

    //     NUMCPF 		30024117870
    //     DTNASCIMENTO	11.09.1970
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private loginService: LoginService,
        private unregisteredScheduleService: UnregisteredScheduleService,
        private scheduleService: ScheduleService,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private router: Router,
        private snackBar: SnackBarService,
        private sanitizer: DomSanitizer,
        private authService: AuthService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true,
                },
                toolbar: {
                    hidden: true,
                },
                footer: {
                    hidden: true,
                },
                sidepanel: {
                    hidden: true,
                },
            },
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit() {
        // A tela de login não deve reutilizar uma sessão expirada de outra visita.
        this.authService.logout();
        this.getLogo();
        this.buscarEmpresa();
        localStorage.removeItem("unregisteredSchedule");

        this.loginForm = this._formBuilder.group({
            cpf: [
                this.cpfPacient ? this.cpfPacient : "",
                [Validators.required],
            ],
            dataNascimento: [
                this.nascimentoPacient ? this.nascimentoPacient : "",
                Validators.required,
            ],
        });
    }

    async autenticate() {
        localStorage.removeItem("cpfpaciente");
        localStorage.removeItem("nascimentopaciente");
        this.progessbar = true;

        if (this.loginForm.valid) {
            let datanascimentoModificada = this.dateFormater(
                this.loginForm.controls.dataNascimento.value
            );
            const dateE = moment(datanascimentoModificada).format("YYYY-MM-DD");
            const credencias = {
                cpf: this.loginForm.controls.cpf.value,
                birthday: dateE,
            };

            try {
                const res = await this.loginService.autenticate(credencias);

                moment.locale("pt");
                const dia = moment(res.birthday).format("DD");
                const mes = moment(res.birthday).format("MMMM");

                const dataAniversario = dia + " de " + mes;
                const usuario = {
                    idPaciente: res.id,
                    nomePaciente: res.name,
                    telefoneCelular: this.celFormatter(res?.phoneStandart),
                    telefone: this.celFormatter(res?.phoneStandart),

                    email: this.validateEmail(res?.email)
                        ? this.emailFormater(res?.email)
                        : res?.email,
                    cpf: this.cpfFormarter(res?.cpf),
                    dataNascimento: dataAniversario,
                    idConvenio: res?.insuranceId,
                };

                localStorage.setItem("paciente", JSON.stringify(usuario));
                // UnregisteredScheduleService.mudarNavigation.emit(true);
                this.router.navigate(["/home"]);
                this.progessbar = false;
            } catch (error) {
                this.progessbar = false;
                this.snackBar.warnMessage("Paciente não encontrado!");

                await this.authenticateAdminForUnregistered();

                const agenda =
                    await this.unregisteredScheduleService.buscarAgendamentoSemCadastro(
                        credencias
                    );
                if (agenda?.[0]?.id) {
                    const cobertura =
                        await this.scheduleService.getProcedureList(
                            agenda[0].insuranceId
                        );
                    const procedureList = cobertura || [];

                    if (procedureList.length) {
                        this.procedure = procedureList.find(
                            (procedure) => procedure.id == agenda[0].procedureId
                        );
                    }

                    const professionalList =
                        await this.scheduleService.getPerformerList();

                    if (professionalList?.length) {
                        this.professional = professionalList.find(
                            (professional) =>
                                professional.performerId ==
                                agenda[0].performerId
                        );
                    }

                    localStorage.setItem(
                        "unregisteredSchedule",
                        JSON.stringify(true)
                    );
                    UnregisteredScheduleService.mudarNavigation.emit(true);
                    this.router.navigate(["/resumo-agenda"], {
                        state: {
                            schedule: {
                                paciente: {
                                    nomePaciente: agenda[0].personName,
                                    telefone: agenda[0].personPhoneStandart,
                                    celular: agenda[0].personPhoneStandart,
                                },
                                dataAgenda: agenda[0].date,
                                horaAgenda: agenda[0].hour,
                                idConvenio: agenda[0].insuranceId,
                                idAgenda: agenda[0].id,
                                idProfissional: agenda[0].performerId,
                                nomeProcedimento:
                                    this.procedure?.name ||
                                    agenda[0].procedureName,
                                nomeConvenio: agenda[0].insuranceName,
                                situacaoAgenda: agenda[0].patientStatus,
                                // nomeEspecialidade: this.professional.nomeEspecialidade
                            },
                        },
                    });
                } else {
                    this.progessbar = false;

                    this.snackBar.errorMessage(
                        "Cadastro / Agendamento não encontrado."
                    );
                }
                this.progessbar = false;
            }
        }
        this.progessbar = false;
    }

    async buscarServicoConvenio(idConvenio) {
        try {
            const cobertura = await this.scheduleService.getProcedureList(
                idConvenio
            );
            return cobertura;
        } catch (error) {}
    }

    async unregisteredSchedule() {
        if (this.loginForm.invalid) {
            this.loginForm.markAllAsTouched();
            this.snackBar.warnMessage(
                "Informe o CPF e a data de nascimento para continuar."
            );
            return;
        }

        this.progessbar = true;
        const credential = this.loginForm.getRawValue();

        try {
            await this.authenticateAdminForUnregistered();
            localStorage.setItem("unregisteredSchedule", JSON.stringify(true));
            await this.router.navigate(["/unregistered-schedule"], {
                state: {
                    credential: {
                        cpf: credential.cpf,
                        dataNascimento: credential.dataNascimento,
                    },
                },
            });
        } catch (error) {
            this.snackBar.errorMessage(
                "Não foi possível iniciar o agendamento sem cadastro."
            );
        } finally {
            this.progessbar = false;
        }
    }

    celFormatter(cel) {
        if (!cel) {
            return "Número não cadastrado";
        }
        if (cel) {
            let celPhone = "";
            let lastField = cel.split("-")[1];
            let size;
            if (lastField == undefined) {
                lastField = cel.split("");
                size = lastField.length;
                if (size > 7) {
                    celPhone =
                        "(**) *****-" +
                        lastField[size - 4] +
                        lastField[size - 3] +
                        lastField[size - 2] +
                        lastField[size - 1];
                } else {
                    celPhone = "Número inválido";
                }
            } else {
                celPhone = "(**) *****-" + lastField;
            }
            return celPhone;
        }
    }

    emailFormater(email) {
        if (email == "") {
            return "Email não cadastrado";
        }
        let emailToShow = "***@***.com";
        let finalEmail = "";
        let provedorEmail = "";
        let emailToShowFinal = "";
        let size;
        if (email) {
            let userEmail = email.split("@")[0]; // salva o inicio do email
            //   emailToShow = "***@" + email.split("@")[1];
            finalEmail = email.split("@")[1]; // salva o final do email
            provedorEmail = finalEmail.split(".")[0]; // salva o provedor do email
            size = provedorEmail.length;
            if (userEmail.length > 2) {
                emailToShow =
                    userEmail[0] +
                    "***" +
                    userEmail[userEmail.length - 1] +
                    "@" +
                    provedorEmail[0] +
                    "***" +
                    provedorEmail[size - 1] +
                    ".";

                if (finalEmail.split(".")[2] == undefined) {
                    emailToShowFinal = finalEmail.split(".")[1];
                } else {
                    emailToShowFinal =
                        finalEmail.split(".")[1] +
                        "." +
                        finalEmail.split(".")[2];
                }
            } else {
                if (userEmail[0] == undefined) {
                    return "Email inválido";
                } else {
                    emailToShow =
                        userEmail[0] +
                        "***" +
                        userEmail[userEmail.length - 1] +
                        "@" +
                        provedorEmail[0] +
                        "***" +
                        provedorEmail[provedorEmail.length - 1] +
                        ".";
                    if (finalEmail.split(".")[2] == undefined) {
                        emailToShowFinal = finalEmail.split(".")[1];
                    } else {
                        emailToShowFinal =
                            finalEmail.split(".")[1] +
                            "." +
                            finalEmail.split(".")[2];
                    }
                }
            }
        }
        return emailToShow + emailToShowFinal;
    }

    dateFormater(date) {
        if (date) {
            let dateField = "";
            let firstField = date.split("/");
            // dateField = firstField + "/**/**";
            dateField =
                firstField[2] + "-" + firstField[1] + "-" + firstField[0];
            return dateField;
        }
    }

    dateFormaterUnregistered(date) {
        if (date) {
            let dateField = "";
            let firstField = date.split("/");

            dateField = firstField[0] + firstField[1] + firstField[2];

            return dateField;
        }
    }

    cpfFormarter(cpf) {
        if (cpf) {
            let cpfField = "";
            let firstFieldShow =
                cpf.split("")[6] + cpf.split("")[7] + cpf.split("")[8];
            let lastFieldShow = "-" + cpf.split("")[9] + cpf.split("")[10];

            cpfField = "***.***." + firstFieldShow + lastFieldShow;

            return cpfField;
        }
    }

    async buscarEmpresa() {
        this.enterprise = await this.loginService.enterprise();
        localStorage.setItem("enterprise", JSON.stringify(this.enterprise));
        this.button = false;
        this.getLogo();
    }

    getLogo() {
        this.loginService.enterpriseLogo().then((result) => {
            if (result.value != null) {
                this.loginService.getInfoCompany(result.value).then((res) => {
                    let eartefact = res;
                    this.sanitizer.bypassSecurityTrustResourceUrl;
                    this.logo = eartefact.content;
                });
            }
        });
    }

    validateEmail(email: string) {
        if (email) {
            var validRegex =
                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

            if (email.match(validRegex)) {
                return true;
            } else {
                return false;
            }
        } else {
            return;
        }
    }

    private authenticateAdminForUnregistered(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.authService
                .login("admin", "teste123", this.authService.getTenantId() || "")
                .subscribe({
                    next: () => resolve(),
                    error: reject,
                });
        });
    }

    // nameFormarter(name) {
    //     if (name) {
    //         let nameField = "";
    //         let firstField = name.split(" ")[0];
    //         let lastField = name.split(" ")[name.split(" ").length - 1];
    //         nameField = firstField + ".***.***-**";
    //         if (firstField.length > 2 && lastField) {
    //             nameField =
    //                 firstField[0] +
    //                 firstField[1] +
    //                 "*** " +
    //                 lastField[0] +
    //                 lastField[1] +
    //                 "***";
    //         }
    //         return nameField;
    //     }
    // }
}
